import moment from 'moment';
import {Injectable} from '@angular/core';
import {cloneDeep} from 'lodash-es';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {TranslateService} from '@ngx-translate/core';

export interface IAnnotationsTreeAutoSave {
  versionId: string;
  lastModified: Date;
  lastModifiedFromNow: string;
  key: string;
}

@Injectable({
  providedIn: 'root'
})
export class AutoSaveService {

  // tslint:disable-next-line:variable-name
  private _annotationTreeAutoSave: IAnnotationsTreeAutoSave[] = [];

  constructor(
    private http: HttpClient,
    public translate: TranslateService,
  ) {
  }

  set annotationTreeAutoSave(values: any[]) {
    moment.locale(this.translate.currentLang);
    const newValues: IAnnotationsTreeAutoSave[] = values.map((aValue) => {
      return {
        key: aValue.key,
        versionId: aValue.versionId,
        lastModified: moment(aValue.lastModified).toDate(),
        lastModifiedFromNow: moment(aValue.lastModified).fromNow(),
        // versionId: '',
        // lastModified: new Date(),
        // lastModifiedFromNow: '',
      } as IAnnotationsTreeAutoSave;
    });

    // console.log(cloneDeep(newValues));
    newValues.shift(); // Le premier est la version 'actuelle'
    this._annotationTreeAutoSave = cloneDeep(newValues);
    // console.log(this._annotationTreeAutoSave);

  }

  get annotationTreeAutoSave(): IAnnotationsTreeAutoSave[] {
    return cloneDeep(this._annotationTreeAutoSave);
  }

  clearService() {
    console.log('** clear datas that where in autoSaveService!');
    this._annotationTreeAutoSave = [];
  }

  getPreviousVersionFromS3(surveyId: string, versionId: string) {
    //
    // console.log('getPreviousVersionFromS3', surveyId, versionId);
    // return this.http.get<any>(`${environment.dashboardDatasBase}/annotations/autoSave/${surveyId}.json?versionId=${versionId}`);
    //
  }


}
